import { render, staticRenderFns } from "./ICAPHeader.vue?vue&type=template&id=b457ede6&scoped=true&"
import script from "./ICAPHeader.vue?vue&type=script&lang=js&"
export * from "./ICAPHeader.vue?vue&type=script&lang=js&"
import style1 from "./ICAPHeader.vue?vue&type=style&index=1&id=b457ede6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b457ede6",
  null
  
)

export default component.exports